<div
  class="modal-container"
  [class.highlights-modal]="isHighlights"
  id="userSettingsModalContainer">
  <header class="modal-header">
    <zbp-icon [iconName]="iconNames.cog"></zbp-icon>
    <h2 class="modal-title text-uppercase">{{ isDistrictWide ? 'DistrictWide User Settings' : 'SchoolWide User Settings' }}</h2>
  </header>
  @if (settingsLoaded) {
    @if (form) {
      <form id="userSettingsForm" [formGroup]="form" (ngSubmit)="save()">
        <div class="modal-body"
          [class.form-disabled]="formDisabled"
          >
          <ul
            #tooltip="ngbTooltip"
            tooltipClass="centered-tooltip"
            [ngbTooltip]="formDisabled ? 'User settings are managed by your organization. Please consult your district administrator for any needed changes.' : ''"
            placement="top"
            triggers="manual"
            (mouseenter)="onTooltipEnter(tooltip)"
            (mouseleave)="onTooltipLeave(tooltip)"
            >
            <!-- Teachers can reset passwords -->
            <li>
              <div class="checkbox-title">
                <input [id]="userSettingsFieldNames.canChangePassword" [name]="userSettingsFieldNames.canChangePassword" type="checkbox" [formControlName]="userSettingsFieldNames.canChangePassword" [attr.aria-describedby]="userSettingsFieldNames.canChangePassword">
                <label class="fw-700" [for]="userSettingsFieldNames.canChangePassword">
                  Allow teachers to reset passwords
                </label>
              </div>
              <p class="setting-description">Restricts the ability for teachers to change or reset their own passwords.</p>
            </li>
            <!-- Teachers can manage licenses -->
            <li>
              <div class="checkbox-title">
                <input [id]="userSettingsFieldNames.canManageLicenses" [name]="userSettingsFieldNames.canManageLicenses" type="checkbox" [formControlName]="userSettingsFieldNames.canManageLicenses" [attr.aria-describedby]="userSettingsFieldNames.canManageLicenses">
                <label class="fw-700" [for]="userSettingsFieldNames.canManageLicenses">
                  Allow teachers to assign licenses
                </label>
              </div>
              @if (!isHighlights) {
                <p class="setting-description">Restricts the ability for teachers to assign their own licenses, either to themselves or to their classrooms. District or school administrators will be solely responsible for assigning licenses to teachers and classrooms.</p>
              } @else {
                <p class="setting-description">Restricts the ability for teachers to assign their own licenses, either to themselves. District or school administrators will be solely responsible for assigning licenses to teachers.</p>
              }
              <ul class="nested-list">
                <li>
                  <p class="setting-description-with-disc">At the beginning of the school year, teachers at schools with available licenses AND this restriction turned on will see the "no licenses available" message.</p>
                </li>
                <li>
                  <p class="setting-description-with-disc">The Licenses page is available to teachers with this restriction, but the +/- buttons are grayed out.</p>
                </li>
              </ul>
            </li>
            @if (!isHighlights) {
              <!-- Create classrooms & students -->
              <li [class.setting-disabled]="usesOneRoster">
                <div class="checkbox-title">
                  <input [id]="userSettingsFieldNames.canManageClassroom" [name]="userSettingsFieldNames.canManageClassroom" type="checkbox" [formControlName]="userSettingsFieldNames.canManageClassroom" [attr.aria-describedby]="userSettingsFieldNames.canManageClassroom">
                  <!-- Disabled form has a tooltip over the list, do not show other tooltips when the form is disabled -->
                  <label class="fw-700" [for]="userSettingsFieldNames.canManageClassroom" [ngbTooltip]="(usesOneRoster && !formDisabled) ? oneRosterToolTipMessage : ''">
                    Allow teachers to create classrooms and student accounts
                  </label>
                </div>
                <p class="setting-description">Restricts the ability for teachers to create their own classrooms and their own students.</p>
                <ul class="nested-list">
                  <li>
                    <p class="setting-description-with-disc">They can only view the student information by clicking the Edit Student popup.</p>
                  </li>
                </ul>
              </li>
              <!-- Create parent users -->
              <li>
                <div class="checkbox-title">
                  <input [id]="userSettingsFieldNames.canManageParent" [name]="userSettingsFieldNames.canManageParent" type="checkbox" [formControlName]="userSettingsFieldNames.canManageParent" [attr.aria-describedby]="userSettingsFieldNames.canManageParent">
                  <label class="fw-700" [for]="userSettingsFieldNames.canManageParent">
                    Allow teachers to create parent users
                  </label>
                </div>
                <p class="setting-description">Restricts the ability for teachers to create parent users for their classrooms.</p>
              </li>
            }
            <!-- Suppress Emails - Only Visible to District Admins -->
            @if (userIsDistrictAdmin) {
              <li>
                <div class="checkbox-title">
                  <input [id]="userSettingsFieldNames.suppressEmails" [name]="userSettingsFieldNames.suppressEmails" type="checkbox" [formControlName]="userSettingsFieldNames.suppressEmails" [attr.aria-describedby]="userSettingsFieldNames.suppressEmails">
                  <label class="fw-700" [for]="userSettingsFieldNames.suppressEmails">
                    Suppress emails to teachers
                  </label>
                </div>
                <p class="setting-description">Prevents {{portalNameToDisplay}} from sending account setup and password reset emails to teachers in situations where a single sign-on integration is in place.</p>
              </li>
            }
          </ul>
        </div>
        <footer class="modal-footer">
          <zbp-button-component
            theme="ghost"
            label="Cancel"
            (click)="dismiss()"
            type="button"
            class="text-uppercase">
          </zbp-button-component>
          <zbp-button-component
            type="submit"
            theme="primary"
            label="Update"
            [showSpinner]="isSaving"
            [disabled]="formDisabled"
            class="text-uppercase">
          </zbp-button-component>
        </footer>
      </form>
    }
  } @else {
    <zbp-preloader class="preloader"></zbp-preloader>
  }


</div>
